import React from 'react';
import { SpotlightManager } from '@atlaskit/onboarding';
import { ExperienceStart } from '@atlassian/experience-tracker';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import JiraRelayEnvironmentProvider from '@atlassian/jira-relay-environment-provider';
import { PAGE_VIEW_EXP_NAME } from './common/constant';
import {
	matchMegaphoneFeaturePreExpandCriteria,
	matchMegaphoneFeaturePostExpandCriteria,
} from './services/megaphone-feature-experiment/match-megaphone-feature-criteria.tsx';
import View from './view/view.tsx';

export type Props = {
	isAdmin: boolean;
	isProjectAdmin: boolean;
	baseUrl: string;
	cloudId: string;
	projectKey: string;
	projectId: string | number;
	projectName: string;
	projectType: string;
	simplified: boolean;
	environment: string | undefined | null;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const fireExperienceFailed = useExperienceFail({ experience: PAGE_VIEW_EXP_NAME });
	const onError = (location: string, error: Error) => {
		fireExperienceFailed(location, error);
	};

	return (
		<JiraRelayEnvironmentProvider>
			<JSErrorBoundary
				id="jiraOpsgenieScheduleAppEntry"
				teamName="fusion-solaris"
				packageName="jiraOpsgenieSchedule"
				onError={onError}
			>
				<AppBase hasErrorBoundary={false}>
					<AppStyle>
						<ExperienceStart name={PAGE_VIEW_EXP_NAME} id="on-call-schedule-experience" />
						<SpotlightManager>
							<View
								{...props}
								isPreExpand={
									matchMegaphoneFeaturePreExpandCriteria() &&
									!matchMegaphoneFeaturePostExpandCriteria()
								}
							/>
						</SpotlightManager>
					</AppStyle>
				</AppBase>
			</JSErrorBoundary>
		</JiraRelayEnvironmentProvider>
	);
};
